  <template>
    <span v-if='!memberLocked'>
      <router-link tag="button" :to="cancelRoute" class='lips btn white --sm'>Cancel</router-link>
      <tool-tip
        message="You may not add dependents to a voided subscriber."
        :top="true"
        :show-tool-tip="primarySubscriberVoided"
      >
        <router-link
          v-if="showAddDependentButton"
          :disabled="primarySubscriberVoided"
          tag="button"
          :to="{name: 'add-dependent', params: { primarySubscriberMemberCk: primarySubscriberCkToUseForDependents }}"
          class="_mls _mt0 btn --sm"
        >
          Add Dependent
        </router-link>
      </tool-tip>

      <async-button
        :disabled="(submitEnabled ? null : 'disabled')"
        class="_mlxs btn lips --sm"
        :executing="isSubmitting"
        @clicked="$emit('submit')">
          <template #buttonContent>
            <span>Submit</span>
          </template>
      </async-button>
    </span>
    <span v-else class='_mr0 _flex align-center'>
      <font-awesome-icon icon='exclamation-triangle' class='_mrxs lips' aria-label="Exclamation point"/>
      <p class='_m0 lips'>
        This member is currently locked and cannot be edited.
      </p>
    </span>
  </template>

  <script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import memberManagement from '@mixins/memberManagement'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import ToolTip from '@molecules/ToolTip'

  export default {
    mixins: [memberManagement],
    computed: {
      showAddDependentButton() {
        return (
          !this.memberDetailsLoading &&
          this.primarySubscriberCkToUseForDependents &&
          !window.location.href.includes('coverage')
        )
      }
    },
    props: {
      cancelRoute: {
        type: Object,
        default() {
          return {
            name: 'member-management'
          }
        }
      },
      submitEnabled: {
        type: Boolean,
        default: true
      },
      savingDraft: {
        type: Boolean,
        default: false
      },
      isSubmitting: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ToolTip,
      FontAwesomeIcon,
      AsyncButton
    }
  }
  </script>
